import { SmartInterviewsBuilder } from '../smart-interviews.types';

export const deleteCandidateSmartInterview = (
  builder: SmartInterviewsBuilder
) =>
  builder.mutation<void, number>({
    query: (id) => ({
      url: `/candidates/smart-interviews/${id}`,
      method: 'DELETE',
    }),
    invalidatesTags: () => [
      { type: 'SmartInterviews' },
      { type: 'SmartInterviewsVideos' },
    ],
  });
